import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { PropsWithChildren } from 'react';
import AppProvider from './AppContext';
import { RelationProvider } from './RelationContext';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 seconds
      gcTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const sessionStoragePersistor = createSyncStoragePersister({
  storage: window.sessionStorage,
});

const CombinedProvider = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        maxAge: 1000 * 60 * 30, // 30 minutes
        persister: sessionStoragePersistor,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => {
            return (
              query.queryKey.includes('persist') &&
              query.state.status !== 'pending'
            );
          },
          shouldDehydrateMutation: (mutation) => {
            return (
              (mutation?.options?.mutationKey?.includes?.('persist') ??
                false) &&
              mutation.state.status !== 'pending'
            );
          },
        },
      }}
    >
      <AppProvider>
        <RelationProvider>{children}</RelationProvider>
      </AppProvider>
    </PersistQueryClientProvider>
  );
};

export default CombinedProvider;
